type ParamValue = string | undefined | null | number | boolean | string[];

type BuildParamsOptions = {
  encodeURIComponents?: boolean;
};

export default function buildParams(
  params: Record<string, ParamValue>,
  { encodeURIComponents = true }: BuildParamsOptions = {},
): string {
  let searchParams = new URLSearchParams();
  for (const entry of Object.entries(params)) {
    searchParams = appendParam(searchParams, entry);
  }

  if ([...searchParams.keys()].length < 1) {
    return "";
  }

  if (!encodeURIComponents) {
    return `?${decodeURIComponent(searchParams.toString())}`;
  }

  return `?${searchParams}`;
}

function serializeValue(
  value: string | undefined | null | number | boolean,
): string | undefined {
  return value?.toString();
}

type Key = string;

function appendParam(params: URLSearchParams, [key, value]: [Key, ParamValue]) {
  const isPresent = (value?: string | null): value is string =>
    (value?.length ?? 0) > 0;

  if (Array.isArray(value)) {
    const serializedValues = value.map((v) => serializeValue(v));
    serializedValues.forEach((val) =>
      isPresent(val) ? params.append(key, val) : null,
    );
    return params;
  }

  const serializedValue = serializeValue(value);
  if (isPresent(serializedValue)) {
    params.set(key, serializedValue);
  }

  return params;
}
